<template>
    <!-- CTA Footer Section -->
    <div class="relative py-16 md:py-24 px-4 md:px-8 overflow-hidden">
        <!-- Decorative elements -->
        <div class="hidden lg:block">
            <img
                src="../../../../images/plus-left-plane.svg"
                alt=""
                class="absolute left-0 bottom-0 w-[300px] pointer-events-none"
            />
            <img
                src="../../../../images/plus-right-plane.svg"
                alt=""
                class="absolute right-0 top-0 w-[320px] pointer-events-none"
            />
            <img
                src="../../../../images/plus-ticket.svg"
                alt=""
                class="absolute left-[5%] top-8 w-[80px] rotate-[15deg] pointer-events-none"
            />
            <img
                src="../../../../images/plus-suitcase.svg"
                alt=""
                class="absolute right-[5%] bottom-12 w-[90px] -rotate-12 pointer-events-none"
            />
        </div>

        <div class="max-w-2xl mx-auto text-center relative z-10">
            <h2 class="text-2xl md:text-3xl font-medium text-slate-800 dark:text-slate-100">
                Your points deserve this.
            </h2>
            <p class="text-slate-500 dark:text-slate-400 text-base mt-3">
                Join 10xTravel+ today. Track your benefits, catch the
                alerts, learn from experts in the community, and start
                booking the trips you've been earning toward - all for $10 a
                month.
            </p>
            <button
                class="mt-6 bg-orange text-white text-sm font-medium py-2.5 px-4 rounded shadow-sm hover:bg-orange-dark transition-colors"
                type="button"
                @click="$emit('checkout')"
            >
                Join 10xTravel+
            </button>
        </div>
    </div>
</template>

<script setup>
defineEmits(['checkout']);
</script>
